import React, { useState } from 'react';
import { Typography, Popover, Box, List, ListItem, ListItemText, Divider } from '@mui/material';

const IncludedSublocationsCell = ({ value, row }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  if (row.original?.isSummaryRow) return null;

  const sublocations = row.original?.sublocations;

  const handleClick = (event) => {
    if (value !== '—') {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Typography
        variant="body2"
        textAlign="left"
        onClick={handleClick}
        sx={{
          color: 'secondary.main',
          cursor: value !== '—' ? 'pointer' : 'default',
          '&:hover': {
            textDecoration: value !== '—' ? 'underline' : 'none',
          },
        }}
      >
        {value || '—'}
      </Typography>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box sx={{ width: 300, maxHeight: 400, overflow: 'auto' }}>
          {sublocations?.selected?.length > 0 && (
            <>
              <Box sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
                <Typography variant="subtitle2" fontWeight={600}>
                  Selected Sublocations ({sublocations.selected.length}/{sublocations.total})
                </Typography>
              </Box>
              <List dense>
                {sublocations.selected.map((sublocation, index) => (
                  <ListItem key={sublocation.id || index}>
                    <ListItemText
                      primary={sublocation.name}
                      sx={{ '& .MuiListItemText-primary': { fontSize: '0.875rem' } }}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}

          {sublocations?.unselected?.length > 0 && (
            <>
              <Divider />
              <Box sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
                <Typography variant="subtitle2" fontWeight={600}>
                  Unselected ({sublocations.unselected.length})
                </Typography>
              </Box>
              <List dense>
                {sublocations.unselected.map((sublocation, index) => (
                  <ListItem key={sublocation.id || index}>
                    <ListItemText
                      primary={sublocation.name}
                      sx={{
                        '& .MuiListItemText-primary': {
                          fontSize: '0.875rem',
                          color: 'text.secondary',
                        },
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}

          {!sublocations?.selected?.length && !sublocations?.unselected?.length && (
            <Box sx={{ p: 2 }}>
              <Typography variant="body2" color="text.secondary">
                No sublocation data available
              </Typography>
            </Box>
          )}
        </Box>
      </Popover>
    </>
  );
};

export default IncludedSublocationsCell;
